import { __decorate, __metadata } from "tslib";
import { Host, h } from "@stencil/core";
import { balBrowser } from "../../utils/browser";
import { balDevice } from "../../utils/device";
import { updateBalAnimated } from "../../utils/config";
import { debounce, rIC, rOnLoad } from "../../utils/helpers";
import { Logger } from "../../utils/log";
import { startFocusVisible } from "../../utils/focus-visible";
export class App {
    constructor() {
        this.debouncedNotify = debounce(() => this.notifyResize(), 100);
        this.notifyResize = async () => {
            if (balBrowser.hasDocument && balBrowser.hasWindow) {
                const doc = document.documentElement;
                doc.style.setProperty('--bal-app-height', `${window.innerHeight}px`);
            }
        };
        this.animated = true;
        this.ready = false;
    }
    createLogger(log) {
        this.log = log;
    }
    connectedCallback() {
        if (this.animated === false) {
            updateBalAnimated(this.animated);
        }
        if (balBrowser.hasWindow) {
            window.addEventListener('resize', this.debouncedNotify);
            this.debouncedNotify();
        }
    }
    componentDidLoad() {
        rIC(() => {
            this.ready = true;
            startFocusVisible();
        });
        rOnLoad(() => {
            if (balBrowser.hasDocument && balBrowser.hasWindow) {
                const doc = document.documentElement;
                doc.classList.add('lcp-ready');
            }
        });
    }
    disconnectedCallback() {
        if (balBrowser.hasWindow) {
            window.removeEventListener('resize', this.debouncedNotify);
        }
    }
    async setFocus(elements) {
        if (this.focusVisible) {
            this.focusVisible.setFocus(elements);
        }
    }
    render() {
        return (h(Host, { key: 'e062237a5407e1f20d5ba64329e264fc0ae41f4e', class: {
                'bal-app': true,
                'bal-app--safari': balBrowser.isSafari,
                'bal-app--touch': balDevice.hasTouchScreen,
            } }, h("slot", { key: '0fdf270bb2737933ba48a2181e98897de19f66ed' })));
    }
    static get is() { return "bal-app"; }
    static get originalStyleUrls() {
        return {
            "$": ["bal-app.sass"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["bal-app.css"]
        };
    }
    static get properties() {
        return {
            "animated": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Disables all animation inside the bal-app. Can be used for simplify e2e testing."
                },
                "getter": false,
                "setter": false,
                "attribute": "animated",
                "reflect": true,
                "defaultValue": "true"
            },
            "ready": {
                "type": "boolean",
                "mutable": true,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [{
                            "name": "internal",
                            "text": "Is `true` when DS components are ready to be shown."
                        }],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "ready",
                "reflect": true,
                "defaultValue": "false"
            }
        };
    }
    static get methods() {
        return {
            "setFocus": {
                "complexType": {
                    "signature": "(elements: HTMLElement[]) => Promise<void>",
                    "parameters": [{
                            "name": "elements",
                            "type": "HTMLElement[]",
                            "docs": ""
                        }],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        },
                        "HTMLElement": {
                            "location": "global",
                            "id": "global::HTMLElement"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            }
        };
    }
    static get elementRef() { return "el"; }
}
__decorate([
    Logger('bal-app'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function]),
    __metadata("design:returntype", void 0)
], App.prototype, "createLogger", null);
